jQuery(document).ready(function() {

    // First check if alert bar exists
    const alertBar = document.getElementById('mwAlertBar');
    if (!alertBar) return;

    const alertId = alertBar.dataset.alertId;
    const startTime = alertBar.dataset.start;
    const endTime = alertBar.dataset.end;

    // Function to check if a cookie exists
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    // Function to set a cookie
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    }

    // Function to check if current time is within range (NY timezone)
    // Note: 'America/New_York' timezone automatically handles DST transitions:
    // - EDT (Eastern Daylight Time, UTC-4) during summer (roughly March-November)
    // - EST (Eastern Standard Time, UTC-5) during winter (roughly November-March)
    // The Intl API handles these transitions automatically based on the date
    function isTimeInRange() {
        // Create a formatter that will give us NY time for comparison
        // This automatically applies EDT or EST based on the current date
        const nyFormatter = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });

        const now = new Date();
        // Get current time in Eastern timezone as a comparable string
        // This will be in EDT or EST automatically depending on the date
        const nyTimeStr = nyFormatter.format(now)
            .replace(/(\d+)\/(\d+)\/(\d+),\s+(\d+):(\d+):(\d+)/, '$3-$1-$2 $4:$5:$6');
        
        // Helper function to convert ACF date string (Y-m-d H:i:s) to Eastern timezone format for comparison
        // ACF dates are stored as "Y-m-d H:i:s" and should be interpreted as Eastern time
        // Since ACF doesn't store timezone info, we assume admin-entered times are in Eastern time
        // (EDT or EST depending on when they were entered, but we compare as-is)
        function formatAsEasternForComparison(dateStr) {
            if (!dateStr) return null;
            // ACF returns "Y-m-d H:i:s" format, which we interpret as Eastern time
            // Convert to same format as nyTimeStr for string comparison: "YYYY-MM-DD HH:mm:ss"
            return dateStr; // Already in the right format!
        }

        // Check start time if it exists
        if (startTime) {
            const startStr = formatAsEasternForComparison(startTime);
            if (startStr && nyTimeStr < startStr) return false;
        }

        // Check end time if it exists
        if (endTime) {
            const endStr = formatAsEasternForComparison(endTime);
            if (endStr && nyTimeStr > endStr) return false;
        }

        return true;
    }

    // Check if we should show the alert
    if (!getCookie(`alert_dismissed_${alertId}`) && isTimeInRange()) {
        alertBar.style.display = 'block'; // or remove a hidden class
    }

    // Handle close button click
    const closeButton = document.getElementById('closeAlertBar');
    if (closeButton) {
        closeButton.addEventListener('click', function() {
            alertBar.style.display = 'none';
            setCookie(`alert_dismissed_${alertId}`, 'true', 365); // Cookie lasts 1 year
        });
    }

});